const $ = jQuery;
import Swal from "sweetalert2";
import loadingSvg from "../assets/loadingSvg.svg";
import MyGamePlanLevelControl from "./MyGamePlanLevelControl";

import OnboardingFlow from "../utils/OnboardingFlow.js";
const onboardingFlowControl = new OnboardingFlow();

export default class MyGamePlanActionFlow {
  constructor(onboardingFlowControl) {
    this.lists = [
      $(".tactical-items-list"),
      $("#action-items-list"),
      $("#completed-goals-list"),
    ];
    this.levelControl = new MyGamePlanLevelControl();
    this.onboardingFlowControl = onboardingFlowControl;

    let completedActions = this.getAllCompletedActionIds();

    this.calculatorUnlocked = completedActions.includes(0);
    this.mediaKitUnlocked = completedActions.length >= 3;
    this.requiredForSilver = [107, 112];
    this.silverUnlocked = this.requiredForSilver.every((actionId) =>
      completedActions.includes(actionId)
    );
  }

  unlockHiddenActions = (li, allCompletedActionIds) => {
    $("ul.tactical-items-list li").each(function () {
      const requiredActionIds = $(this).data("requirements");
      if (
        requiredActionIds &&
        requiredActionIds.includes(li.data("actionId")) &&
        allCompletedActionIds.every((id) => requiredActionIds.includes(id))
      ) {
        $(this).removeClass("hidden");
      }
    });
  };

  bindEvents = () => {
    this.lists[0].on("click", "li:not(.disabled)", (event) => {
      const li = $(event.currentTarget);
      li.addClass("disabled");
      li.append(`<img src="${loadingSvg}" class="loading-svg">`);
      const actionId = li.data("actionId");
      this.markCompleted(actionId, () => {
        li.addClass("completed");
        this.confettiLauncher(actionId);
        //After 1 second delay set the display to none
        setTimeout(() => {
          // animate the li height to 0
          li.animate(
            {
              height: 0,
            },
            500,
            () => {
              // Set li display to none
              li.css("display", "none");
              // Add the completed action to the completed goals html list
              this.moveItem(actionId, 0, 2);
              li.find("img.loading-svg").remove();
              li.removeClass("completed");
              li.removeClass("action-item");
              li.off("click");
              li.css("display", "flex");
              li.css("height", "unset");
              this.showNextActions();
              const completedActionIds = this.getAllCompletedActionIds();
              this.categoryUnlock(actionId);
            }
          );
        }, 1000);

        // If no more tasks are left within the parent category, add text saying "All done for this category! Great job!"
        if (li.parent().children().length == 1) {
          li.parent().append(
            `<li class="all-done">All done for this category! Great work!</li>`
          );
        }
      });
    });

    // this.lists[1].on("click", "li:not(.disabled)", (event) => {
    //   const li = $(event.currentTarget);
    //   li.addClass("disabled");
    //   li.append(`<img src="${loadingSvg}" class="loading-svg">`);
    //   const actionId = li.data("actionId");
    //   this.markCompleted(actionId, () => {
    //     const completedActionIds = this.getAllCompletedActionIds();

    //     this.moveItem(actionId, 1, 2);
    //     li.addClass("completed");
    //     this.confettiLauncher(actionId);
    //     //After 1 second delay set the display to none
    //     setTimeout(() => {
    //       // animate the li height to 0
    //       li.animate({
    //           height: 0,
    //         },
    //         500, () => {
    //           // Set li display to none
    //           li.css("display", "none");
    //         }
    //       );
    //     }, 1000);

    //     setTimeout(() => {
    //       this.showNextActions();
    //     }, 200);
    //   });
    // });

    this.initialChecks();
  };

  initialChecks = () => {
    this.showNextActions();
  };

  showNextActions = () => {
    let completedActionIds = this.getAllCompletedActionIds();
    this.levelControl.updateLevel(completedActionIds);
    this.checkMediaKitUnlock(completedActionIds);
    this.checkSilverUnlocks(completedActionIds);
    const tacticalItems = $("ul.tactical-items-list li");
    tacticalItems.each((index, li) => {
      const requiredActionIds = $(li).data("requirements");

      if (requiredActionIds) {
        requiredActionIds.forEach((id) => {
          if (completedActionIds.includes(parseInt(id))) {
            $(li).removeClass("hidden");
          }
        });
      }
    });
  };

  // Function to unlock "Dream Brand Deals" and "Affiliated Campaigns" when the user completes action id 107
  categoryUnlock = () => {
    let completedActionIds = this.getAllCompletedActionIds();
    if (completedActionIds.includes(107) &&completedActionIds.includes(111)) {
      // Only run if the "Dream Brand Deals" and "Affiliated Campaigns" categories are locked
      if ($("#dream_brand_deals").css("display") == "flex" && $("#affiliate_campaigns").css("display") == "flex") {
        onboardingFlowControl.unlockCategories(
          ["Dream Brand Deals", "Affiliate Campaigns"],
          () => {
            // Reload page
            location.reload();
          }
        );
      }
    }
  };

  checkMediaKitUnlock = (allCompletedActionIds) => {
    //run only after 3 actions are completed. Unlocks media kit menu
    if (allCompletedActionIds.length == 3 && !this.mediaKitUnlocked) {
      this.onboardingFlowControl.unlockMenu("mediakit", () => {
        $("ul.tactical-items-list")
          .find("li[data-action-id='0']")
          .removeClass("hidden");
        // get the class of the locked Media Kit Menu and unlock it.
        $("div#user-menu-wrapper ul li.mediakit-unlockable-menu")
          .first()
          .removeClass("disabled");
        // alert the user that the new item is unlocked
        Swal.fire({
          title: "New Area Unlocked!",
          width: "26em",
          customClass: {
            title: "swal2-title gc-alert-text",
            confirmButton: "the-btn third-btn",
            htmlContainer: "swal2-html-container gc-warning-text",
          },
          html: "Media Kit is now unlocked on the menu!",
          icon: "success",
        });
        $("ul.tactical-items-list")
          .find("li[data-action-id='0']")
          .removeClass("hidden");
      });
    }
  };

  handleCalculatorMenuUnlock = () => {
    if (!this.calculatorUnlocked) {
      this.onboardingFlowControl.unlockMenu("calculator", () => {
        // get the class of the locked Calculator Menu and unlock it.
        $("div#user-menu-wrapper ul li.calculator-unlockable-menu")
          .first()
          .removeClass("disabled");
        // alert the user that the new item is unlocked
        Swal.fire({
          title: "New Area Unlocked!",
          width: "26em",
          customClass: {
            title: "swal2-title gc-alert-text",
            confirmButton: "the-btn third-btn",
            htmlContainer: "swal2-html-container gc-warning-text",
          },
          html: "Rate Calculator is now unlocked on the menu!",
          icon: "success",
        });
        this.calculatorUnlocked = true;
      });
    }
  };

  checkSilverUnlocks = (allCompletedActionIds) => {
    // silver level reached, unlock everything else
    if (
      this.requiredForSilver.every((actionId) =>
        allCompletedActionIds.includes(actionId)
      ) &&
      !this.silverUnlocked
    ) {
      this.onboardingFlowControl.unlockMenu("find_a_contact", () => {
        $("div#user-menu-wrapper ul li.find_a_contact-unlockable-menu")
          .first()
          .removeClass("disabled");

        this.onboardingFlowControl.unlockCategories(["affiliate"], () => {
          let affiliateRow = $(
            ".cs-row:has(.section-label-content:contains('Affiliate'))"
          );
          affiliateRow.removeClass("locked");
          affiliateRow.next(".locked-row-message").remove();

          Swal.fire({
            title: "Silver Level Reached!",
            width: "26em",
            customClass: {
              title: "swal2-title gc-alert-text",
              confirmButton: "the-btn third-btn",
              htmlContainer: "swal2-html-container gc-warning-text",
            },
            html: "Congratulations! You're now a Silver Creator and you've unlocked the entire platform!",
            icon: "success",
          });

          this.silverUnlocked = true;
        });
      });
    }
  };

  getAllCompletedActionIds = () => {
    return $.map(this.lists[2].find("li"), (li) =>
      parseInt($(li).data("actionId"))
    );
  };

  getRequiredActionNames = (actionIds) => {
    return actionIds
      .map((actionId) => {
        const requiredAction = $(`li[data-action-id='${actionId}']`);
        const requiredActionName = requiredAction.text();
        return `<li>${requiredActionName}</li>`;
      })
      .join("");
  };

  moveItem = (itemId, oldListIndex, newListIndex) => {
    const item = this.lists[oldListIndex].find(
      `li[data-action-id="${itemId}"]`
    );
    if (oldListIndex === 0) {
      if ($("#action-items-help-text").length) {
        $("#action-items-help-text").remove();
      }
      item.attr("data-requirements", JSON.stringify([]));
    } else if (oldListIndex === 1) {
      if ($("#completed-goals-help-text").length) {
        $("#completed-goals-help-text").remove();
      }
    }
    item.find(".loading-svg").remove();
    this.lists[newListIndex].append(item);
  };

  markPending = (itemId, successCallback) => {
    $.ajax({
      url: CSWP.ajax_url,
      method: "POST",
      dataType: "json",
      data: {
        action: "cs_handle_my_game_plan_status_change",
        status: "progress",
        id: itemId,
        user: CSWP.user,
        _ajax_nonce: CSWP.nonce,
      },
      success: (response) => {
        if (response.success) {
          successCallback();
        } else {
          console.log("Error marking item as pending: Internal error");
        }
      },
      error: (jqXHR, textStatus, errorThrown) => {
        console.log(`Error marking item as pending: ${errorThrown}`);
      },
    });
  };

  markCompleted = (itemId, successCallback, errorCallback) => {
    const data = {
      action: "cs_handle_my_game_plan_status_change",
      status: "completed",
      id: itemId,
      user: CSWP.user,
      _ajax_nonce: CSWP.nonce,
    };

    const options = {
      url: CSWP.ajax_url,
      method: "POST",
      dataType: "json",
      data: data,
      success: (response) => {
        if (response.success) {
          // Handle MediaKit Completion unlocking Calculator here...
          if (itemId == 0) {
            this.handleCalculatorMenuUnlock();
          }
          successCallback();
        } else {
          console.log("Error marking item as completed: Internal error");
        }
      },
    };

    if (errorCallback) {
      options.error = (jqXHR, textStatus, errorThrown) => {
        console.log(`Error marking item as completed: ${errorThrown}`);
        errorCallback();
      };
    } else {
      options.error = (jqXHR, textStatus, errorThrown) => {
        console.log(`Error marking item as completed: ${errorThrown}`);
      };
    }

    $.ajax(options);
  };

  confettiLauncher = (itemId) => {
    function random(max) {
      return Math.random() * (max - 0) + 0;
    }

    let c = document.createDocumentFragment();

    for (let i = 0; i < 100; i++) {
      let styles =
        "transform: translate3d(" +
        (random(500) - 250) +
        "px, " +
        (random(200) - 150) +
        "px, 0) rotate(" +
        random(360) +
        "deg); background: hsla(" +
        random(360) +
        ",100%,50%,1); animation: bang 1000ms ease-out forwards; opacity: 0";

      let e = document.createElement("i");
      e.style.cssText = styles.toString();
      //  convert this to JQuery: c.appendChild(e);
      $(c).append(e);
    }
    $(".tactical-items-list")
      .find(`li[data-action-id="${itemId}"]`)
      .find(".radio")
      .append(c);
  };
}
